module.exports = __webpack_public_path__ + "img/txt_info3.f95077e3.png";